import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Textarea } from "@chakra-ui/react";
import { TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { MdApproval  as ApprovalIcon} from "react-icons/md";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { BatchApprovalB } from "./Modal";
import apiCall from '../../../utils/apiCall';
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from '@chakra-ui/react';
import { FaRegFileAlt as FileIcon } from "react-icons/fa";
import {useAtom,atom} from 'jotai'
import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format, setDate } from "date-fns";

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function DefermentRequest() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const [selected_status,set_selected_status] = useState<null | string>(null);
  const {data:all_exam_request,isLoading} = useQuery<any>(['all-exam-deferment-request'],{
    queryFn: async ()=> await apiCall().get('/Exam/GetAllExamDefermentRequests'),
    select(data:any){return data.data.Data}
  })
  const [search,set_search] = useState('');

  const [filter_data,set_filter_data] = useState<any>(all_exam_request);


  const showBatchAproval = () =>{
    set_modal({
      header:'Batch Approval',
      content:<BatchApprovalB/>
    })
    set_open(true);
  }
  const handleSearch = (e: any) => {
    const val = e.target.value;
    set_search(val);
  
    if (val.trim() !== "") {
      const new_data = all_exam_request.filter((eData: any) =>
        Object.values(eData).join('').toLowerCase().includes(val.toLowerCase())
      );
  
      if (new_data.length > 0) {
        set_filter_data(new_data); 
        set_notification(''); 
      } else {
        set_filter_data([]); 
        set_notification('No matching results found'); 
      }
    } else {
      set_filter_data(all_exam_request); 
      set_notification(''); 
    }
  };
  
  
  
  
  // const handleSearch = (e:any)=>{
  //   let val = e.target.value;
  //   set_search(val);
  //   if(val){
  //     let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
  //     if(new_data.length > 0)set_filter_data(new_data)
  //     else set_filter_data(all_exam_request)
  //   }
  //   else set_filter_data(all_exam_request)
  // }

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  useEffect(()=>{
    if(selected_status){
      let data = all_exam_request.filter((eData:any) => eData.Status.toLowerCase() === selected_status.toLowerCase());
        set_filter_data(data);
      
    }
    else{
      set_filter_data(all_exam_request);
    }
  },[selected_status])

  useEffect(()=>{
    set_filter_data(all_exam_request)
  },[all_exam_request])

  return (
    <> 
    {isLoading?<Loader />:
    <Box>
      <TopDisplay label="Deferment Request Approval" button_array={[
          <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<ApprovalIcon/>}     variant="outline"
            colorScheme="var(--dark-green-color)"
            onClick={showBatchAproval}
          >Batch Approval</Button>,
          // <UploadButton label="Upload Candidates" />
        ]} />
       <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)" pos="relative">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <Select placeholder="Status" width="130px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_status(e.target.value)}>
              <option>Approved</option>
              <option>Rejected</option>
              <option>Pending</option>
              <option>Verified</option>
          </Select>

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Pending Deferment request</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
              {/* <Th sx={HeadStyle}>Deferment Id</Th> */}
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>Subjects</Th>
                <Th sx={HeadStyle}>Exam Diet</Th>
                <Th sx={HeadStyle}>Reason</Th>
                <Th sx={HeadStyle}>Date Requested</Th>
                <Th sx={HeadStyle}>Status</Th>
                <Th sx={HeadStyle}>Date Approved</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.DefermentId}>
                {/* <Td sx={DataStyle}>{eCandidate.FirstName}</Td> */}
                {/* <Td sx={DataStyle}>{eCandidate.DefermentId}</Td> */}
                <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                <Td sx={DataStyle}>
                    {eCandidate?.SubjectNames?.map((eSubject:any)=>eSubject)?.join(',')?.length >31?eCandidate?.SubjectNames?.map((eSubject:any)=>eSubject)?.join(',').slice(0,31)+' ...':eCandidate?.SubjectNames?.map((eSubject:any)=>eSubject)?.join(',')||'N/A'}
                  </Td>
                  <Td sx={DataStyle}>{eCandidate.ExamPeriodName}</Td>
                 <Td title={eCandidate.Reason} sx={{ ...DataStyle, p: 2, whiteSpace: 'normal', maxWidth: '180px' }}>
                {eCandidate.Reason || 'N/A'}</Td>
                <Td sx={DataStyle}>
                        {format(new Date(eCandidate.CreateDate), "dd/MM/yyyy")}
                        <br />
                        {format(new Date(eCandidate.CreateDate), "hh:mm a")}
                      </Td>
                 <Td sx={DataStyle}>{eCandidate.Status}</Td>
                 <Td sx={DataStyle}>
                        {format(new Date(eCandidate.ActionDate), "dd/MM/yyyy")}
                        <br />
                        {format(new Date(eCandidate.ActionDate), "hh:mm a")}
                      </Td>
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Deferment Request'  
      }
        <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
    </>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom)
  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }
  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Student Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

  const handleSingleApproval = () =>{
    set_index(null);
    set_modal({
      header:'Deferment Approval Request',
      content:<ViewSingleApproval {...candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
          <GridItem sx={sx} p="8px 4px" onClick={handleSingleApproval}>Approve/Reject</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  //console.log(props,'props')
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
      <Flex gap="20px">
        {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
        <Text width="150px"  fontWeight="bold" color="var(--light-text)">Student NO:</Text>
        <Text fontWeight="500">  {props.candidate.StudentNo}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" gap="30px">
     
    {/* <GridItem as={Flex} gap="20px">
      <Text width="150px"  fontWeight="500" color="var(--light-text)">Deferment Id</Text>
      <Text fontWeight="500">{props.candidate.DefermentId || 'Not available'}</Text>
    </GridItem> */}
          <GridItem as={Flex} gap="20px">
        <Text width="150px" fontWeight="bold" color="var(--light-text)">
          Subject Name:
        </Text>
        <Text fontWeight="500">
          {Array.isArray(props.candidate.SubjectNames)
            ? props.candidate.SubjectNames.join(', ')
            : props.candidate.SubjectNames || 'N/A'}
        </Text>
      </GridItem>
        <GridItem as={Flex} gap="20px">
      <Text width="150px"  fontWeight="bold" color="var(--light-text)">Exam Diet:</Text>
      <Text fontWeight="500">{props.candidate.ExamPeriodName || 'N/A'}</Text>
    </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="bold" color="var(--light-text)">Reason:</Text>
        <Text fontWeight="500">
          {props.candidate.Reason || 'N/A'}
        </Text>
      </GridItem >
      {/* <GridItem as={Flex} gap="20px" alignItems="center">
      <Text width="150px" fontWeight="bold" color="var(--light-text)">
        Created Date:
      </Text>
      <Text fontWeight="500">
      {format(new Date(props.ActionDate), "dd/MM/yyyy")|| "N/A"}
      </Text>
    </GridItem>
    <GridItem as={Flex} gap="20px" alignItems="center">
      <Text width="150px" fontWeight="bold" color="var(--light-text)">
        Approved Date:
      </Text>
      <Text fontWeight="500">
      {format(new Date(props.ActionDate), "dd/MM/yyyy")|| "N/A"}
      </Text>
    </GridItem> */}
      <GridItem as={Flex} gap="20px">
        <Text width="150px" fontWeight="bold" color="var(--light-text)">Status:</Text>
        <Text fontWeight="500">{props.candidate.Status || 'Pending'}</Text>
      </GridItem>
      <GridItem as={Flex} flexDir="column">
      <Heading>Evidence</Heading>
      <iframe src={props?.candidate?.Path} title="Evidence" style={{minWidth:'600px',width:'80dvw',height:'90vh'}}></iframe>
      </GridItem>
    </Grid>
  </Flex>
  )}
  const ViewSingleApproval = (props:any) =>{
    const [,set_open] = useAtom(openAtom);
    const [,set_n_open] = useAtom(openNAtom);
    const [,set_modal] = useAtom(modalAtom)
    const [,set_notification] = useAtom(notificationAtom);
    const queryClient = useQueryClient();
    const [Rejection,set_RejectionComment] = useState(props?.Rejection || '');
    // console.log(props,'props');

    const {isLoading:approveIsLoading,mutate:update_deferment_approve} = useMutation({
      mutationKey:['new-approve-deferment-request'],
      mutationFn: async(defermentId:string)=> {
       // console.log(defermentId,'test id')
        return await apiCall().post(`/Exam/ApproveDefermentRequest?defermentId=${defermentId}`)
        .then(data =>{
          set_open(false);
        })
        .catch((error:any)=>{
         // console.log(error,'error')
          set_notification({
            type:'error',
            message:error.response.data.Message ||error.message || 'Error Occured'
          });
          set_n_open(true);
          set_open(false);
        })
      },
        onSuccess(data:any){
         //console.log(data,'data')
         set_notification({
           type:'success',
           message:data.data.Message || 'Deferment Request Approve Successfully'
         });
         set_n_open(true);
         queryClient.invalidateQueries(['all-deferment-request'])
       },
    
      onError(error:any){
        set_notification({
          type:'error',
          message:error.data.Message || 'Error Occured'
        });
        set_n_open(true);
        set_open(false);
      },
      onSettled(){
        set_open(false);

      }
    })
    // const {isLoading:rejectIsLoading,mutate:update_deferment_reject} = useMutation({
    //   mutationKey:['new-reject-deferment-request'],
    //   mutationFn: async(defermentId:number)=>{ 
    //    // console.log(defermentId,'test id')
    //     return await apiCall().post(`/Exam/RejectDefermentRequest?defermentId=${defermentId}`)
    //     .catch((error:any)=>{
    //       //(error,'error')
    //       set_notification({
    //         type:'error',
    //         message:error?.response?.data?.Message || 'Error Occured'
    //       });
    //       set_n_open(true);
    //       set_open(false);
    //     })
    //   },
    //   onSuccess(data:any){
    //     console.log(data,'data')
    //     set_notification({
    //       type:'success',
    //       message:data.data.Message || 'Deferment Request Rejected Successfully'
    //     });
    //     set_n_open(true);
    //     queryClient.invalidateQueries(['all-deferment-request'])
    //   },
    //   onError(error:any){
    //     set_notification({
    //       type:'error',
    //       message:error.response?.data?.Message ||'Error Occured'
    //     });
    //     set_n_open(true);
    //   },
    //   onSettled(data,error){
    //     //console.log(data,error,'test both')
    //     set_open(false);

    //   }
    // })
    // const {isLoading:rejectIsLoading,mutate:update_deferment_reject} = useMutation({
    // mutationKey: ['new_reject_deferment'],
    // mutationFn: async (defermentId: string, comment: string) => {
    //     const data = {
    //       DefermentId: [defermentId],
    //       RejectionComment: comment,
    //     };
    //     return await apiCall()
    //       .post(`/Exam/RejectDefermentRequest?defermentId=${defermentId}`, data)
    //       .then((data) => {
    //         // console.log(data, 'data approve data');
    //         set_open(false);
    //         set_notification({
    //           type: 'success',
    //           message: data.data.Message || 'Deferment Request Rejected Successfully',
    //         });
    //         set_n_open(true);
    //         queryClient.invalidateQueries(['all-exam-deferment-request']); // Ensures cache invalidation
    //       })
    //       .catch((error: any) => {
    //         // console.log(error, 'error')
    //         set_notification({
    //           type: 'error',
    //           message: error.response?.data?.Message || error.message || 'Error Occurred',
    //         });
    //         set_n_open(true);
    //         set_open(false);
    //       });
    //   },
    //   onSuccess: () => set_open(false), // Close modal or UI on success (optional)
    //   onError: () => set_open(false),   // Close modal or UI on error (optional)
    //   onSettled: () => set_open(false),   // Close modal or UI after settlement (optional)
    // });
    const {isLoading:rejectIsLoading,mutate:update_deferment_reject} = useMutation({
      mutationKey: ['new-reject-deferment-request'],
      mutationFn: async(defermentId) => {
        const DefermentId = Array.isArray(defermentId) ? defermentId : [defermentId];
       
        
        const requestBody = JSON.stringify({
          DefermentId,
          RejectionComment:Rejection
        });
    
        return await apiCall().post(`/Exam/RejectDefermentRequest`, requestBody, {
          headers: {
            'Content-Type': 'application/json' 
          }
        })
        .then(data => {
          set_open(false);
          return data;
        })
        .catch((error) => {
          set_notification({
            type: 'error',
            message: error.response.data.Message || error.message || 'Error Occurred'
          });
          set_n_open(true);
          set_open(false);
        });
      },
      onSuccess(data:any){
        //console.log(data,'data')
        set_notification({
          type:'success',
          message:data.data.Message || 'Deferment Request Rejected Successfully'
       });
        set_n_open(true);
        set_open(false);
        queryClient.invalidateQueries(['all-exam-deferment-request']);
      },
      onError(error:any){
        set_notification({
           type:'error',
           message:error.response?.data?.Message ||'Error Occured'
         });
        set_n_open(true);
        set_open(false);
      },
      onSettled() {
        set_open(false);
      }
    });
    
    // const handleViewEvidence = () =>{
    //   set_modal({
    //     header:'Evidence',
    //     content:<iframe src={props?.Path} title="Evidence" style={{width:'90dvh',height:'90dvw'}}>

    //     </iframe>
    //   })
    //   set_open(true)
    // }

    const handleViewEvidence = () => {
      set_modal({
        header: 'Evidence',
        content: (
          <iframe
            src={props?.Path}
            title="Evidence"
            style={{ width: '90vw', height: '90vh' }}
          />
        ),
      });
      set_open(true);
    };

    useEffect(()=>{
      console.log(rejectIsLoading,approveIsLoading,'isLoading')
    },[rejectIsLoading,approveIsLoading])

    return(
      <Flex flexDir="column" minWidth="600px" gap="30px" p="20px" bg="white" borderRadius="md" boxShadow="lg">
      <Flex flexDir="column" gap="20px">
        <Flex gap="20px" align="center">
          <Text fontWeight="bold" minWidth="150px">Student No:</Text>
          <Text m="0">{props?.StudentNo || "Not available"}</Text>
        </Flex>
    
        <Flex gap="20px" align="center">
          <Text fontWeight="bold" minWidth="150px">Subject Name:</Text>
          <Text m="0">
            {Array.isArray(props?.SubjectNames)
              ? props.SubjectNames.join(', ')
              : props?.SubjectNames || 'Not available'}
          </Text>
        </Flex>
    
        <Flex gap="20px" align="center">
          <Text fontWeight="bold" minWidth="150px">Reason:</Text>
          <Text m="0">{props?.Reason || "Not available"}</Text>
        </Flex>
    
        <Flex gap="20px" align="center">
          <Text fontWeight="bold" minWidth="150px">Requested Date:</Text>
          <Text m="0">
            {props?.CreateDate
              ? `${format(new Date(props?.CreateDate), "dd/MM/yyyy")} at ${format(new Date(props?.CreateDate), "hh:mm a")}`
              : "Not available"}
          </Text>
        </Flex>
    
        <Flex gap="20px" align="center">
          <Text fontWeight="bold" minWidth="150px">Approved Date:</Text>
          <Text m="0">
            {props?.ActionDate
              ? `${format(new Date(props?.ActionDate), "dd/MM/yyyy")} at ${format(new Date(props?.ActionDate), "hh:mm a")}`
              : "Not available"}
          </Text>
        </Flex>
    
        <Flex gap="20px" align="center">
          <Text fontWeight="bold" minWidth="150px">Evidence:</Text>
          <Button
            bg="green.500"
            color="white"
            _hover={{ bg: "green.600" }}
            onClick={handleViewEvidence}
          >
            View Evidence
          </Button>
        </Flex>
    
        <Flex gap="20px" align="center">
          <Text fontWeight="bold" minWidth="150px">Status:</Text>
          <Text m="0">{props?.Status || "Not available"}</Text>
        </Flex>
      </Flex>
    
      {/* Comment Section */}
      <Flex flexDir="column" gap="10px">
        <Text fontWeight="bold">Comment</Text>
        <Textarea
          placeholder="Add a comment..."
          resize="vertical"
          size="sm"
          borderColor="gray.300"
          onChange={(e) => set_RejectionComment(e.target.value)}
        />
      </Flex>
    
      {/* Actions */}
      <Flex justify="center" gap="20px" mt="20px">
        <Button
          onClick={() =>
            approveIsLoading || rejectIsLoading
              ? {}
              : update_deferment_approve(props.DefermentId)
          }
          bg="green.500"
          color="white"
          _hover={{ bg: "green.600" }}
          width="130px"
          isDisabled={approveIsLoading || rejectIsLoading}
        >
          {approveIsLoading ? "Loading" : "Approve"}
        </Button>
    
        <Button
          onClick={() =>
            approveIsLoading || rejectIsLoading
              ? {}
              : update_deferment_reject(props.DefermentId, Rejection)
          }
          colorScheme="red"
          width="130px"
          isDisabled={rejectIsLoading || approveIsLoading}
        >
          {rejectIsLoading ? "Loading" : "Reject"}
        </Button>
      </Flex>
    </Flex>
  )}
  
